<template>
	<div class="compList" @dragstart="handleDragStart">
		<div draggable="true">{{ widgetType.TEXT }}</div>
		<div draggable="true">{{ widgetType.DATE }}</div>
		<div draggable="true">{{ widgetType.IMAGE }}</div>
		<div draggable="true">{{ widgetType.STACK }}</div>
		<div draggable="true">{{ widgetType.SPACER }}</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { widgetType, dataKey } from '../types';

export default defineComponent({
	setup() {
		const handleDragStart = (e: DragEvent) => {
			const target = e.target as HTMLElement;
			const type = target.innerText;
			const dataTransfer = e.dataTransfer as DataTransfer;
			dataTransfer.setData(dataKey.TYPEOFADDEDWIDGET, type);
		};
		return { widgetType, handleDragStart };
	},
});
</script>

<style scoped>
.compList {
	margin-top: 20px;
	border: hotpink 2px solid;
}
.compList div {
	border: 1px brown solid;
	margin: 5px;
	padding: 2px;
	width: min-content;
	cursor: grab;
}
.compList div:active {
	cursor: grabbing;
}
</style>
